import URI from 'jsuri';
import Q from 'q';

import API from 'js/lib/api';
import user from 'js/lib/user';

const api = API('/api/onDemandHomeProgress.v1', { type: 'rest' });

export const getHomeProgress = (courseId: string): Q.Promise<any> => {
  const userCourseId = `${user.get().id}~${courseId}`;
  const url = new URI(userCourseId).addQueryParam('fields', 'modulesCompleted,modulesPassed');
  return Q(api.get(url.toString()));
};
